<template>  
  <div class="portfolios-paging">
    <i :class="['icon-chevron-double-left','clickable-ico', (page === 0 ? 'pale' : 'clickable')]"
        @click="click('begin')"></i>
    <i :class="['icon-chevron-left','clickable-ico', (page === 0 ? 'pale' : 'clickable')]"
        @click="click('backward')"></i>        
    <span>
      {{page*pagelen + 1}} .. {{(page + 1)*pagelen}} из {{total}}        
    </span>
    <i :class="['icon-chevron-right','clickable-ico', (page === maxPage ? 'pale' : 'clickable')]"
        @click="click('forward')"></i>
    <i :class="['icon-chevron-double-right','clickable-ico', (page === maxPage ? 'pale' : 'clickable')]"
        @click="click('end')"></i>
  </div>
</template>

<script>
  export default {
      props: ['page', 'pagelen', 'total'],
      data() {
        return {          
        };
      },
      computed: {
        maxPage() {
          return Math.ceil(this.total / this.pagelen) - 1;
        }
      },
      methods: {
        click(action) {
          let direction = action === 'begin' || action === 'backward' ? -1 : 1;
          if (direction < 0 && this.page === 0) return;
          if (direction > 0 && this.page === this.maxPage) return;
          this.$emit('navigate', action);
        }
      }
    };
</script>

<style scoped>
  div.portfolios-paging {
    display: flex;
    width: 100%;
    justify-content: center;
    background-color: #3d536b;
    font-family: Arimo;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 3.64;
    letter-spacing: 0.4px;
    text-align: center;
    border-radius: 0px 0px 4px 4px;
  }

  div.portfolio-odd  {
    background: #F8F8F8;
  }

  .clickable {
    cursor: pointer;
    margin-left: 9px;
    margin-right: 9px;
    font-size: 13px;
    line-height: 3.64;
  }

  i.pale {
    color: #aaa;
    margin-left: 9px;
    margin-right: 9px;
    font-size: 13px;
    line-height: 3.64;
  }
</style>
